import React, { FC } from 'react';

import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";
import { Medium } from "@/constants/mediums";

const GasReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.gas} />;
};

export default GasReadingsDetailPage;
